/* eslint-disable react/no-danger */
import React, { memo, useCallback } from 'react';
import useProductWsMessageData from '../../../hooks/inbox/data/useProductWsMessageData';
import MessageStatusMC from './MessageStatusMC';
import GroupSenderMC from './GroupSenderMC';
import ImageMC from '../../../components/ImageMC';

/**
 * ProductWsMessageMC - Mensaje de producto de catálogo WhatsApp en el Inbox.
 */
const ProductWsMessageMC = memo(({ conversation, message, onImageClick }) => {
  const {
    data,
    productName,
    productDetailsHtml,
    captionHtml,
    url
  } = useProductWsMessageData({ platform: conversation.platform, message });

  const handleImageClick = useCallback(() => {
    if (!url || typeof onImageClick !== 'function') return;
    onImageClick(message.id || message.identifier);
  }, [url, onImageClick, message.id, message.identifier]);

  return (
    <div className="tw-wrapper tw-p-2 tw-bg-white tw-rounded-[9px]">
      <GroupSenderMC message={message} />

      <div className="tw-flex tw-items-center tw-media-caption">
        {(productName || productDetailsHtml) && (
          <div className="tw-p-2 tw-flex-1 tw-min-w-0">
            {productName && (
              <div className="tw-text-xs tw-font-semibold tw-text-gray-800 tw-mb-1">
                {productName}
              </div>
            )}
            {productDetailsHtml && (
              <div
                className="tw-whitespace-pre-line tw-text-left tw-text-xs tw-font-sans tw-text-gray-600"
                dangerouslySetInnerHTML={{ __html: productDetailsHtml }}
              />
            )}
          </div>
        )}
        {url && (
          <div className="tw-p-2 tw-w-[100px] tw-h-[100px] tw-flex-shrink-0">
            <ImageMC
              platform={conversation.platform}
              data={data}
              onClick={handleImageClick}
              className="tw-block tw-w-full tw-h-full tw-object-cover tw-rounded-[9px] tw-bg-white tw-cursor-pointer !tw-max-w-none !tw-max-h-none"
            />
          </div>
        )}
      </div>

      {captionHtml && (
        <div
          className="tw-whitespace-pre-line tw-text-sm tw-mt-1"
          dangerouslySetInnerHTML={{ __html: captionHtml }}
        />
      )}

      <MessageStatusMC message={message} platform={conversation.platform} />
    </div>
  );
});

ProductWsMessageMC.displayName = 'ProductWsMessageMC';

export default ProductWsMessageMC;
